import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

export function SparkleIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M12 2l2.2 5.1L19 9l-4.8 3.4L12 18l-2.2-5.6L5 9l4.8-1.9L12 2z" stroke="currentColor" fill="currentColor" />
      <path d="M5 19l.8-1.8L7 16l-2 .8L3 16l.8 2z" stroke="currentColor" fill="currentColor" opacity="0.5" />
      <path d="M20 7l.8-1.8L22 4l-2 .8L18 4l.8 2z" stroke="currentColor" fill="currentColor" opacity="0.6" />
    </svg>
  );
}

export function BrushIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M3 21c3 0 5-2 5-5a5 5 0 00-5 5z" fill="currentColor" opacity="0.12" />
      <path d="M15 4l5 5" />
      <path d="M4 16l11-11 5 5L9 21H4v-5z" />
    </svg>
  );
}

export function LayersIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M12 2l9 5-9 5-9-5 9-5z" />
      <path d="M3 12l9 5 9-5" opacity="0.7" />
      <path d="M3 17l9 5 9-5" opacity="0.4" />
    </svg>
  );
}

export function SparkIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M12 2l1.5 6.5L20 10l-6.5 1.5L12 18l-1.5-6.5L4 10l6.5-1.5L12 2z" fill="currentColor" opacity="0.2" />
      <path d="M12 2l1.5 6.5L20 10l-6.5 1.5L12 18l-1.5-6.5L4 10l6.5-1.5L12 2z" />
    </svg>
  );
}

export function BoltIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" fill="currentColor" opacity="0.22" />
      <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" />
    </svg>
  );
}

export function CloudArrowUpIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M16 16l-4-4-4 4" />
      <path d="M12 12v9" />
      <path d="M20 18a4 4 0 0 0-.9-7.9 6 6 0 0 0-11.7 1.6A4.5 4.5 0 0 0 4 16a4 4 0 0 0 4 4h12" />
    </svg>
  );
}
